import { SRModal } from '@sr/ui'
import PropTypes from 'prop-types'
import { BUTTON_COLORS, Divider, Form } from '@shared/ui'
import { Button } from '@shared/storybook'
import { useTranslation } from 'react-i18next'
import { TrashCan } from '@carbon/icons-react'
import {
  DoubleModalContainer,
  DoubleModalFormContainer,
  DoubleModalInfoContainer,
  modalContainerClassName,
  DoubleModalWarningText,
  DoubleModalWarningTextContainer,
} from './styles'
import { ModalAgendaActionButton } from '../../styles'

export const DoubleModal = ({
  isSuscriptionControl,
  onClose,
  isEdit,
  isReadOnly,
  methods,
  formSlot,
  infoSlot,
  onSubmit,
  onDelete,
  toggleEdit,
  cancelEvent,
  toggleCancelEvent,
  isEditing,
  appointmentId,
  onClickDeleteAppointment,
}) => {
  const { t } = useTranslation()
  const isCoordinator = formSlot.props.isCoordinator || infoSlot.props.isCoordinator
  
  return (
    <SRModal onClose={onClose} className={isEdit && modalContainerClassName}>
      <Form methods={methods}>
        <DoubleModalContainer>
          <DoubleModalFormContainer $isEdit={isEdit}>
            {formSlot}
          </DoubleModalFormContainer>
          {isEdit && (
            <>
              <Divider vertical />
              <DoubleModalInfoContainer>{infoSlot}</DoubleModalInfoContainer>
            </>
          )}
        </DoubleModalContainer>
        <ModalAgendaActionButton>
          {toggleEdit && isEdit ? ( 
            <>
              {isCoordinator && isSuscriptionControl && (
                <Button
                  variant="tertiary"
                  size="lg"
                  testId="event-form-edit-button"
                  onClick={() => onClickDeleteAppointment()}
                >
                  <div className="flex items-center">Eliminar cita <TrashCan size={22} className="ml-2" /></div>
                </Button>
              )}
              {isEditing ? (
                <>
                  <Button
                    variant="secondary"
                    size="lg"
                    className="ml-auto"
                    testId="event-form-edit-button"
                    onClick={toggleCancelEvent ? toggleCancelEvent : onClose}
                    disabled={isReadOnly}
                  >
                    {t('common:cancel')}
                  </Button>
                  <Button
                    size="lg"
                    className="ml-4"
                    testId="event-form-submit-button"
                    onClick={onSubmit}
                    disabled={isReadOnly}
                  >
                    {t('agenda.formModal.saveButton')}
                  </Button>
                </>
              ) : (
                <Button
                  size="lg"
                  className="ml-auto"
                  testId="event-form-edit-button"
                  onClick={toggleEdit}
                  disabled={isReadOnly}
                >
                  {t('agenda.formModal.editButton')}
                </Button>
              )}
            </>
          ) : (
            <Button
              size="lg"
              className="ml-4"
              testId="event-form-submit-button"
              onClick={onSubmit}
              disabled={isReadOnly}
            >
              {t('agenda.formModal.saveButton')}
            </Button>
          )
          }
        </ModalAgendaActionButton>
        {cancelEvent && (
          <SRModal onClose={toggleCancelEvent}>
            <DoubleModalWarningTextContainer>
              <DoubleModalWarningText>
                {t('common:warningCancelDate')}
              </DoubleModalWarningText>
              <Button
                variant="secondary"
                size="lg"
                testId="event-form-cancel-button"
                onClick={onDelete}
                disabled={isReadOnly}
                color={BUTTON_COLORS.secondary}
              >
                {t('agenda.formModal.cancelButton')}
              </Button>
            </DoubleModalWarningTextContainer>
          </SRModal>
        )}
      </Form>
    </SRModal>
  )
}
DoubleModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  methods: PropTypes.object.isRequired,
  formSlot: PropTypes.node.isRequired,
  infoSlot: PropTypes.node.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  cancelEvent: PropTypes.bool,
  toggleCancelEvent: PropTypes.func,
  appointmentId: PropTypes.string,
}

DoubleModal.defaultProps = {
  isEdit: false,
  isReadOnly: false,
  onDelete: null,
  cancelEvent: false,
  appointmentId: '',
}
